<template lang="">
    <div>
        <v-card :elevation="0" class="v-sheet theme--light br-0">
            <v-card-title>
                <v-row class="col-md-12">
                    <v-col cols="12" sm="12" md="6">
                        Administración de Tipos de Empresa
                    </v-col>
                    <v-col cols="12" sm="12" md="6">
                        <v-btn
                            color=""
                            dark
                            class="mb-2 float-right bg-light-blue"
                            
                            @click="modalNuevo"
                        >
                            Crear nueva
                        </v-btn>
                    </v-col> 
            
                </v-row>
                <v-row class="col-md-12 m-0 p-0">
                    <v-divider></v-divider>
                </v-row>
            </v-card-title>
                        
            <v-card-text>
                <v-data-table
                        :headers="headers"
                        :items="tiposEmpresa"
                        item-key="Id"
                        class="elevation-0"
                        :loading="tableLoading"
                        no-data-text="No hay datos para mostrar"
                    
                        :items-per-page="10"
                        dense
                    >
                    <template v-slot:item="{ item }">
                        <tr>
                            <td>{{ item.id }}</td>
                            <td>{{ item.tipo }}</td>
                            <td>
                                <v-chip
                                        class="ma-2"
                                        :color="item.estado_Id === 1 ? 'teal' : 'orange' "
                                        text-color="white"
                                        small
                                    >
                                        {{item.estado}}
                                </v-chip>
                            </td>
                            <td>
                                <v-btn class="ma-2" small tile outlined color="indigo" @click="obtenerDatosItem(item.id)">
                                    <v-icon left>mdi-pencil</v-icon> Actualizar
                                </v-btn>
                            </td>
                        </tr>
                    </template>

                </v-data-table>
            </v-card-text>
        </v-card>
        <!-- Inicio:: Dialog para mostrar los datos de la etnia-->
    <v-dialog
        v-model="dialog"
        max-width="400px" 
        persistent 
        transition="dialog-bottom-transition"
        
    >
        
        <v-card scrollable>
            <v-card-title>
                {{modalTitle}}
                
                <v-spacer></v-spacer>
                <v-btn
                    icon
                    :disabled="btnRegistroLoading"
                    @click="dialog = false; resetForm()"
                    class="float-right"
                >
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card-title>
            <v-divider></v-divider>
            <v-form
                ref="form"
                v-on:submit.prevent="registrarItem"
                v-model="validForm"
                >
                <v-card-text>
                    <v-row>
                        <v-col  md="12" sm="12" xs="12" class="pt-1 pb-1">
                            <v-text-field
                                outlined
                                autocomplete="off"
                                class="required"
                                dense
                                v-model="datostipoEmpresa.tipo"
                                label="Tipo de Empresa"
                                :rules="[
                                    required(
                                        'Tipo de Empresa'
                                    )
                                ]"
                            ></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col  md="12" sm="12" class="pt-1 pb-1">
                             <label class="grey--text body-2">Estado</label>
                                <v-switch
                                    v-model="switchItemEstado"
                                    inset
                                    :label="switchItemEstado ? 'Activo' : 'Inactivo'"
                                    >
                                </v-switch>
                        </v-col>
                    </v-row>

                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                            <v-btn
                                color="grey lighten-5"
                                elevation="0"
                                class="mb-2 float-right grey lighten-5"
                                @click="dialog = false; resetForm()"
                                :disabled="btnRegistroLoading"
                            >
                                Cancelar
                            </v-btn>
                            <!--:disabled="!validDocForm" type="submit"-->
                            <v-btn
                                color="primary"
                                class="mb-2 float-right"
                                type="submit"
                                :elevation="0" 
                                :disabled="!validForm" 
                                :loading="btnRegistroLoading"                         
                            >
                                {{btnRegistroText}}
                            </v-btn>
                </v-card-actions>
            </v-form>
        </v-card>
    </v-dialog>


    <!-- Fin:: Dialog para mostrar los datos de la etnia-->

    <!--Dialog loader -->
    <dialog-loader
        :dialogVisible="dialogLoaderVisible"
        :text="dialogLoaderText"
    ></dialog-loader>
    <!---->

    <!--Inicio:: Snack alert-->
    <SnackAlert ref="snackalert"></SnackAlert>
    <!-- Fin:: Snack alert-->
    </div>
</template>
<script>
import validations from "@/core/untils/validations.js";

import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { OBTENER_TIPOS_EMPRESA, OBTENER_TIPO_EMPRESA, REGISTRAR_TIPO_EMPRESA, ACTUALIZAR_TIPO_EMPRESA } from "@/core/services/store/tiposempresa.module";
import SnackAlert from '@/view/content/SnackAlert.vue';
import DialogLoader from "@/view/content/DialogLoader";
export default {
    name: "AdminTiposEmpresa",
    components: {
    SnackAlert,
    DialogLoader
    },
        data() {
        return {
            validForm:false,
            itemName : "Tipos Empresa",
            dialog: false,
            modalTitle: 'Registrar Tipo Empresa',
            btnRegistroLoading: false,
            dialogLoaderVisible: false,
            dialogLoaderText: 'Obteniendo informacion....',
            btnRegistroText: 'Registrar Tipo Empresa',
            accion: 1,
            tiposEmpresa: [],
            switchItemEstado: true,
            datostipoEmpresa: {
            id: 0,
            tipo: '',   
            fecha_Creacion: '2021-07-23',   
            usuario_Creacion: 'admin',   
            fecha_Actualizacion: '2021-07-23', 
            usuario_Actualizacion: '',
            estados_Id: 1
            },           
            tableLoading: false,
            ...validations
        } 
    },
    methods: {
        modalNuevo(){
            this.accion =1;
            this.modalTitle='Registrar Tipo Empresa';
            this.btnRegistroText='Registrar Tipo Empresa';
            this.dialog=true;
        },

        resetForm(){
            this.$refs.form.reset();
        },

        //!Obtener las etnias para la tabla
        obtnenerItems(){
            this.tableLoading = true;
            this.tiposEmpresa=[];
            
            this.$store
                .dispatch(OBTENER_TIPOS_EMPRESA)
                .then(() => {
                    this.tiposEmpresa = this.$store.state.tiposempresa.tiposEmpresas;
                    this.tableLoading =false;
                //console.log(this.etnias)
                })
                .catch(() => {
                    this.tableLoading = false;
                });
        },

        obtenerDatosItem(Id){
            this.dialogLoaderVisible=true;
            this.datostipoEmpresa.id = Id;
            this.accion=2;
            this.modalTitle='Actualizar Tipo de Empresa';
            this.btnRegistroText='Actualizar Tipo de Empresa';

            this.$store
                .dispatch(OBTENER_TIPO_EMPRESA, Id)
                .then(() => {
                    this.datostipoEmpresa = this.$store.state.tiposempresa.tipoEmpresa;
                    this.datostipoEmpresa.estados_Id === 1 ? this.switchItemEstado = true : this.switchItemEstado = false;
                    //console.log(this.datosEtnia)
                    this.dialog = true;
                    this.dialogLoaderVisible = false;
                })
                .catch(error => {
                    this.dialogLoaderVisible = false;
                    console.log(error)
                });
        },
        registrarItem(){
            this.btnRegistroLoading=true;
            this.switchItemEstado ? this.datostipoEmpresa.estados_Id = 1 : this.datostipoEmpresa.estados_Id = 2;

            if(this.accion===1){
                this.datostipoEmpresa.id = 0;
                this.$store
                    .dispatch(REGISTRAR_TIPO_EMPRESA, this.datostipoEmpresa)
                    .then(res => {
                        //console.log(res)
                        if(res.status===200){
                            this.obtnenerItems();
                            this.dialog=false;
                            this.$refs.snackalert.SnackbarShow('success', 'Mensaje', res.mensaje);
                            this.resetForm();
                            this.switchItemEstado = true;
                        } else {
                            this.$refs.snackalert.SnackbarShow('warning', 'Alerta', res.mensaje);
                        }
                        this.btnRegistroLoading=false;
                    })
                    .catch(error => {
                        //console.log(error)
                        this.$refs.snackalert.SnackbarShow('warning', 'Alerta', error);
                        this.btnRegistroLoading=false;
                    });

                        

            } else {
                this.$store
                    .dispatch(ACTUALIZAR_TIPO_EMPRESA, this.datostipoEmpresa)
                    .then(res => {
                        //console.log(res)
                        if(res.status===200){
                            this.obtnenerItems();
                            this.dialog=false;
                            this.$refs.snackalert.SnackbarShow('success', 'Mensaje', res.mensaje);
                            this.resetForm();
                            this.switchItemEstado = true;
                        } else {
                            this.$refs.snackalert.SnackbarShow('warning', 'Alerta', res.mensaje);
                        }
                        this.btnRegistroLoading=false;
                    })
                    .catch(error => {
                        //console.log(error)
                        this.$refs.snackalert.SnackbarShow('warning', 'Alerta', error);
                        this.btnRegistroLoading=false;
                    });

            }
        }
    },
    mounted() {
        //Definir el nombre en el breadcrumb
        this.$store.dispatch(SET_BREADCRUMB, [
            { title: "Administración", route: "/dashboard" },
            { title: "Catalogos" },
            { title: "Tipos de Empresa" }
        ]);
    },

    created(){
        this.obtnenerItems();
    },

    computed: {
        headers() {
            return [
                {
                    text: "Id",
                    align: "start",
                    sortable: true,
                    value: "id"
                },
                {
                    text: "Tipo de empresa",
                    value: "tipo"
                },
                {
                    text: "Estado",
                    value: "estado"
                },
                {
                    text: "Acciones",
                    value: "Acciones"
                }
            ]
        }
    }
}
</script>
<style lang="">
    
</style>